import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import AnimatedCup from 'components/common/AnimatedCup';

const propTypes = {
  drawBlockedReason: PropTypes.string,
  customerNumber: PropTypes.string,
};

const defaultProps = {
  drawBlockedReason: 'DEFAULT',
};

const reservedDrawBlockedReasons = [
  'DRAW_PENDING',
  'DRAW_DISABLED_FOR_FROZEN_CONTRACT',
  'PAYMENT_HOLIDAY',
  'LIMIT_USED',
  'NO_ACTIVE_MOBILE_WALLET_ACCOUNT',
];

const WithdrawalBlocked = ({ drawBlockedReason, customerNumber }) => {
  const isDrawPending = drawBlockedReason === 'DRAW_PENDING';
  const isWarning = !reservedDrawBlockedReasons.includes(drawBlockedReason);
  const blockClasses = cx({
    'withdrawal-feedback': true,
    'withdrawal-feedback--pending': isDrawPending,
    'withdrawal-feedback--used': drawBlockedReason === 'LIMIT_USED',
    'withdrawal-feedback--country-fi': COUNTRY === 'FI',
    'withdrawal-feedback--no-mw-account': drawBlockedReason === 'NO_ACTIVE_MOBILE_WALLET_ACCOUNT',
    'withdrawal-feedback--frozen': drawBlockedReason === 'DRAW_DISABLED_FOR_FROZEN_CONTRACT',
    'withdrawal-feedback--warning': isWarning,
    'withdrawal-feedback--in-holiday': drawBlockedReason === 'PAYMENT_HOLIDAY',
  });

  const reason = drawBlockedReason.toLowerCase();

  return (
    <div className={blockClasses}>
      {isDrawPending && <AnimatedCup />}
      <div className="withdrawal-feedback__content">
        <h3 className="withdrawal-feedback__title">
          <FormattedMessage id={`selfservice.withdrawal_blocked.${reason}.title`} values={{ customerId: customerNumber }} />
        </h3>
        <p>
          <FormattedHTMLMessage id={`selfservice.withdrawal_blocked.${reason}.text`} values={{ customerId: customerNumber }} />
        </p>
      </div>
    </div>
  );
};

WithdrawalBlocked.propTypes = propTypes;
WithdrawalBlocked.defaultProps = defaultProps;

export default WithdrawalBlocked;
